module.exports = __webpack_public_path__ + "img/live1.7fc46df1.png";